import qs from "qs";
import axios from "axios";

const url = process.env.VUE_APP_API_BASE_URL;

function getReport(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/dashboard/pos-products-report`, options).then((response) => {
    return {
      data: response.data.data,
      meta: response.data.meta,
    };
  });
}

function getAllReport(params) {
  const options = {
    // 1, not true: in a query string "true" fails Laravel's boolean rule (422).
    params: { ...params, all: 1 },
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/dashboard/pos-products-report`, options).then((response) => {
    return { data: response.data.data, meta: response.data.meta };
  });
}

function getFilters(params) {
  const options = {
    params: params || {},
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios
    .get(`${url}/dashboard/pos-products-report-filters`, options)
    .then((response) => {
      return { data: response.data.data, meta: response.data.meta };
    });
}

export default {
  getReport,
  getAllReport,
  getFilters,
};
